module.exports = __webpack_public_path__ + "img/starfish.be5030ca.webp";